import Vue from 'vue';
import { mapGetters } from 'vuex';
import path from 'path';
import _ from 'lodash';
import Editor from '@tinymce/tinymce-vue';
import fonts from '@editor/fonts.json';
import fontColors from '@editor/droplets/_bubble-options/components/inline-text/font-colors.json';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';

export default Vue.component('dynamic-input-wysiwyg', {
  template: require('./template.html'),
  name: 'dynamic-input-wysiwyg',
  mixins: [guid, uploader],
  computed: {
    ...mapGetters(['currentSite', 'activeSiteType']),
    fontList() {
      const webSafe = _.clone(fonts.webSafe);
      const customFonts = this.currentSite.fonts;
      const totalList = webSafe.concat(_.clone(fonts.list), customFonts).sort();
      return totalList.map(f => `${f}=${f};`).join('');
    },
    colors() {
      const customColors = this.currentSite.colorPalette;
      const list = [];
      _.forEach(fontColors, (hex) => {
        list.push(hex, hex);
      });
      _.forEach(customColors, (color) => {
        list.push(color.value.hex, color.value.hex);
      });
      return list;
    },
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
  ],
  components: {
    Editor,
    uploadProgress,
  },
  data() {
    return {
      apiKey: process.env.TINY_MCE_API_KEY,
      uuid: null,
      tinyLoader: false,
      hideTextEditor: true,
      bucketPath: '_droplet-assets/_blogs/',
      $tinymce: null,
      plugins: [
        'preview',
        'wordcount',
        'link',
        'image',
        'codesample',
        'emoticons',
        'advlist',
        'lists',
        'media',
        'code',
        'pagebreak',
        'hr',
      ],
      toolbar: 'fontselect fontsizeselect | bold italic underline forecolor link | alignleft aligncenter alignright | backcolor | image media | bullist numlist | emoticons pagebreak | codesample code',
      fontSizes: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
      display: {},
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
          this.hideTextEditor = false;
          this.tinyLoader = true;
        } else {
          this.hideTextEditor = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      this.uuid = this.guid();
      this.bucketPath = `_droplet-assets/${this.activeSiteType}/`;
      this.$set(this.display, this.type, this.activeItem[this.type] || '');
    },
    uploadImage(cb) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      const self = this;
      input.onchange = async function onFileChange() {
        const file = this.files[0];
        const title = file.name;
        const filePath = `/${self.bucketPath}${path.basename(title)}`;
        const progress = self.$refs.progress.$el;

        if (progress) {
          // move the progress component into the tinyMce image upload modal
          const modalContent = document.querySelectorAll('[id^=dialog-describe_] .tox-dialog__body-content .tox-form')[0];
          modalContent.insertBefore(progress, modalContent.firstChild);
        }

        const upload = await self.uploadFile({
          file: `${self._sitePath}${filePath}`,
          body: file,
        });

        cb(upload.Location, { title });
      };
      input.click();
    },
    initEditor() {
      this.$tinymce = tinymce;
      this.tinyLoader = false;
    },
    updateText() {
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: this.type,
        val: this.getInputVal(this.display[this.type]),
      });
      const plainText = this.$tinymce.activeEditor.getContent({ format: 'text' });
      const val = this.getInputVal(plainText);
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: 'plainText',
        val,
      });
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem,
        key: `${this.type}PlainText`,
        val,
      });
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/wysiwyg/index.js